import { H1, H6 } from 'au-gatsby-ds/components';
import styled from 'styled-components';
import { mediaQueryMax } from 'components/Grid';

export const ProductHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  border-bottom: none;
  margin-bottom: 32px;

  ${mediaQueryMax.medium`
    margin-top: 12px;
  `}
`;

export const ProductPromoTitle = styled.h1`
  margin: 0;
  ${H1}
`;

export const PricingPromoContainer = styled.div<{ strikethrough: boolean }>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  row-gap: 12px;

  > :last-child {
    margin-left: 10px;

    ${mediaQueryMax.medium`
      margin: 4px 50px 0 0;
    `}
  }

  ${H6}
  font-weight: 700;

  ${props =>
    props.strikethrough &&
    `
    ${OriginalPrice} {
      text-decoration-line: line-through;
      font-weight: 400;
      color: #BDBDBD;
    }
  `}
`;
export const OriginalPrice = styled.span`
  font-size: 16px;
`;

export const StrikethroughPrice = styled.span`
  text-decoration-line: none;
  font-size: 16px;
`;

export const ValuePropText = styled.p`
  font-family: 'Crimson Text', serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
`;
